<template>
  <!-- 标题文字组件 -->
  <el-dialog :visible="headerDialog" :show-close="false" class="text-dialog" center :title="data.title" width="42%">
    <div class="header-text">
      <template v-if="data.desc">
        <p v-for="content in desc" :key="content">{{ content }}。</p>
      </template>
      <template v-if="data.img">
        <div style="height:10px;"></div>
        <h5>{{ data.img.title }}</h5>
        <el-row>
          <block v-for="(item, index) in imgSrc" :key="index">
            <template v-if="typeof item === 'object'">
              <el-col v-for="(item1, index1) in item" :key="index1" :span="12">
                <img :style="{ height: '80px' }" :src="item1" alt="" />
              </el-col>
            </template>
            <template v-if="typeof item === 'string'">
              <img :src="item" alt="" />
            </template>
          </block>
        </el-row>
      </template>
    </div>
    <div class="colseText">
      <el-button @click="colseDialog" type="text" icon="el-icon-circle-close" />
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    // 对话框状态
    headerDialog: {
      type: Boolean,
      default: false
    },
    // 文本数据
    data: {
      type: Object,
      required: true
    }
  },

  computed: {
    desc() {
      const arr1 = this.data.desc.split('。')
      // eslint-disable-next-line no-unused-vars
      let arr2 = []
      const body = arr1.map(item => {
        if (item.includes('.')) {
          arr2 = item.split('.')
          return ''
        }
        return item.trim()
      })

      return [...body, ...arr2].filter(item => item)
    },

    imgSrc() {
      return this.data.img.src
    }
  },

  methods: {
    // 关闭对话框事件
    colseDialog() {
      // 清空数据
      this.textDialog = {
        header: '',
        desc: []
      }
      this.$emit('update:headerDialog', false)
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  height: 100%;
}
</style>
